import { render, staticRenderFns } from "./TargetEventBase.vue?vue&type=template&id=53fc0c56&scoped=true&"
import script from "./TargetEventBase.vue?vue&type=script&lang=js&"
export * from "./TargetEventBase.vue?vue&type=script&lang=js&"
import style0 from "./TargetEventBase.vue?vue&type=style&index=0&id=53fc0c56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc0c56",
  null
  
)

export default component.exports